






















































































































































































































































































































































































import Vue from 'vue'
import moment from 'moment'

import {
  GetStackWithSiplah,
  Stack,
  Siplah,
  SiplahParameter,
  PatchSiplah,
  GetStackUIDFromSiplah,
  SiplahRequiredParameter,
  GetSIPLAHRequiredParameters,
  ViewSiplahJSON,
  SubmitToSiplah,
} from '@/api/cems'

import { TimeZone, FindTimeZone } from '@/api/static'

import JSONViewerDialog from '@/components/json-view-dialog-tabs.vue'

export default Vue.extend({
  name: 'SettingStackSIPLAH',
  components: {
    JSONViewerDialog,
  },
  data() {
    return {
      optsFunction: [
        'count',
        'integral',
        'mean',
        'median',
        'mode',
        'sum',
        'min',
        'max',
        'constant',
        'custom',
      ],

      optsTimeZone: [] as TimeZone[],
      gettingRequiredParameters: false,
      requiredParams: [] as SiplahRequiredParameter[],

      stackUid: '',
      stack: { siplah: {} as Siplah } as Stack,
      parameterMap: [] as SiplahParameter[],
      deletedParameter: [] as number[],

      formTest: {
        date: moment().format('YYYY-MM-DD'),
        time: new Date().getHours(),
      },
      jsonData: {},
      showJSON: false,
      submitOnProgress: false,
    }
  },
  methods: {
    getStaticData() {
      FindTimeZone()
        .then((tz) => {
          this.optsTimeZone = tz
        })
        .catch(() => {
          //
        })
    },

    async getStackWithSiplah() {
      this.stack = await GetStackWithSiplah(this.stackUid)
    },

    async getStackUID() {
      if (this.stack.siplah != undefined) {
        this.stack.siplah.uid = await GetStackUIDFromSiplah(
          this.stack.siplah.code
        )
      }
    },

    async patchStack() {
      this.stack = await PatchSiplah(
        this.stackUid,
        this.deletedParameter,
        this.stack
      )
    },

    async getRequiredParams() {
      this.requiredParams = []
      this.gettingRequiredParameters = true
      setTimeout(() => {
        this.gettingRequiredParameters = false
      }, 5000)

      this.requiredParams = await GetSIPLAHRequiredParameters(this.stackUid)
      this.gettingRequiredParameters = false

      for (const par of this.requiredParams) {
        let exist = false
        for (let i = 0; i < this.parameterMap.length; i++) {
          if (this.parameterMap[i].parameter == par.nama) {
            exist = true
            break
          }
        }

        if (!exist) {
          this.parameterMap.push({
            parameter: par.nama,
            id: 0,
            function: 'mean',
            siplahId: this.stack.siplah?.id || 0,
            source: '',
            valueBroken: 0,
            valueCalibration: 1,
            valueStop: 1,
          })
        }
      }
    },

    async getJSONDataInSIPLAHFormat() {
      const measurementTime = moment(
        this.formTest.date + 'T' + this.formTest.time,
        'YYYY-MM-DDTHH'
      ).valueOf()
      this.jsonData = await ViewSiplahJSON(this.stackUid, measurementTime)
    },

    submitParameter() {
      this.submitOnProgress = true
      const measurementTime = moment(
        this.formTest.date + 'T' + this.formTest.time,
        'YYYY-MM-DDTHH'
      ).valueOf()

      SubmitToSiplah(this.stackUid, measurementTime)
        .then((res) => {
          if (res.success) {
            this.$toast.success(res.message)
          } else {
            if (res.message.length > 64) {
              this.$toast.error('Something wrong.')
              console.log(res.message)
            } else {
              this.$toast.error(res.message)
            }
          }
          this.submitOnProgress = false
        })
        .catch((err) => {
          this.$toast.error('Something wrong.')
          console.log(err)
          this.submitOnProgress = false
        })
    },

    onFormSubmit(e: Event) {
      e.preventDefault()

      if (this.stack.siplah) {
        this.stack.siplah.parameters = this.parameterMap
      }

      this.patchStack()
      this.deletedParameter = []
    },
    onFormTestSubmit(e: Event) {
      e.preventDefault()
      this.submitParameter()
    },

    addParameterMap() {
      this.parameterMap.push({
        id: 0,
        siplahId: this.stack.siplah?.id || 0,
        function: 'mean',
        source: '',
        parameter: '',
        valueBroken: 0,
        valueCalibration: 1,
        valueStop: 1,
      })
    },
    deleteParameterMap(index: number) {
      const parameterId = this.parameterMap[index].id
      if (parameterId != 0) {
        this.deletedParameter.push(parameterId)
      }

      this.parameterMap.splice(index, 1)
    },
    resetParameterMap() {
      this.parameterMap = JSON.parse(
        JSON.stringify(this.stack.siplah?.parameters || [])
      )
      this.deletedParameter = []
    },

    async showJSONData() {
      await this.getJSONDataInSIPLAHFormat()
      this.showJSON = true
    },
  },

  async created() {
    this.getStaticData()
    this.stackUid = this.$route.params.stackUID
    await this.getStackWithSiplah()
    this.resetParameterMap()
  },
})
